import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MilestoneOptions, getTypes, tiersInsideTypes, findTier } from "./MilestoneOptions";

export default function MilestoneForm() {
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");
  const [award, setAward] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [message, setMessage] = useState("");
  const [badgeName, setBadgeName] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const isEdit = Boolean(id);

  const selectedTier = findTier(type, award);

  useEffect(() => {
    if (!id) return;
    axios
      .post(
        process.env.REACT_APP_API_URL + "V1/milestones/fetch",
        { id },
        { headers: { Authorization: "Bearer " + localStorage.getItem("_token") } }
      )
      .then((response) => {
        const m = response.data.data;
        setCategory(m.category);
        setType(m.type);
        setAward(String(m.award));
        setDescription(m.description);
        setBadgeName(m.label ?? "");
        setImageUrl(m.image_url ?? "");
        console.log("Fetched milestone:", m);
      })
      .catch(() => setMessage("Could not load this milestone."));
  }, [id]);

  const saveMilestone = (e) => {
    e.preventDefault();

    if (!category || !type || !award || !badgeName) {
      setMessage("Please pick a category, type, award, and badge name.");
      return;
    }

    const formData = new FormData();
    formData.append("category", category);
    formData.append("type", type);
    formData.append("award", award);
    formData.append("description", description);
    if (image) formData.append("image", image);
    if (isEdit) formData.append("id", id);
    formData.append("label", badgeName);

    const url = isEdit ? "V1/milestones/update" : "V1/milestones/create";

    axios
      .post(process.env.REACT_APP_API_URL + url, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("_token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          setMessage(isEdit ? "Milestone updated, redirecting..." : "Milestone created, redirecting...");
          setTimeout(() => navigate("/milestones/all"), 1500);
        } else {
          setMessage(JSON.stringify(response.data.message));
        }
      })
      .catch((error) => {
        setMessage(JSON.stringify(error.response?.data?.message || "Something went wrong"));
      });
  };

  const awardOptions = [1,5,10,15,20,25,30,50,75,100,365];
  
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h1 className="m-0">{isEdit ? "Edit Milestone" : "Create Milestone"}</h1>
        </div>
      </div>

      <form onSubmit={saveMilestone}>
        <div className="card-body">
          {message && <div className="alert alert-info">{message}</div>}

          <div className="form-group">
            <label>Category*</label>
            <select className="form-control" value={category}
              onChange={(e) => { setCategory(e.target.value); setType(""); setAward(""); }}>
              <option value="">Select category</option>
              {MilestoneOptions.map((c) => (
                <option key={c.value} value={c.value}>{c.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Type*</label>
            <select className="form-control" value={type}
              onChange={(e) => { setType(e.target.value); setAward(""); }}>
              <option value="">Select type</option>
              {getTypes(category).map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>

          {/*
          <div className="form-group">
            <label>Award</label>
            <select className="form-control" value={award}
              onChange={(e) => setAward(e.target.value)}>
              <option value="">Select award</option>
              {awardOptions.map((award) => (
                <option key={award} value={award}>{award}</option>
              ))}
            </select>
          </div>
          */}

        <div className="form-group">
          <label>Award*</label>
          <input
            type="text"
            inputMode="numeric"
            className="form-control"
            list="awardOptions"
            value={award}
            placeholder="Select or type an award"
            onChange={(e) => setAward(e.target.value.replace(/\D/g, ""))}
        />
          <datalist id="awardOptions">
            {awardOptions.map((a) => (
              <option key={a} value={a} />
            ))}
          </datalist>
        </div>

        <div className="form-group">
            <label>Badge Name*</label>
            <input
              type="text"
              className="form-control"
              value={badgeName}
              placeholder="30 Day Standing"
              onChange={(e) => setBadgeName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <input 
              type="text"
              className="form-control"
              value={description}
              placeholder = "You have been awarded for sharing Stand Strong 50 times!"
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="form-group">
  <label>Image</label>
  {imageUrl && (
    <img
      src={imageUrl}
      alt="Current badge"
      style={{ display: "block", maxWidth: "120px", marginBottom: "8px" }}
    />
  )}
  <input
    type="file"
    accept="image/*"
    className="form-control"
    onChange={(e) => {
      const file = e.target.files[0];
      setImage(file);
      if (file) setImageUrl(URL.createObjectURL(file));
    }}
  />
</div>

        </div>

        <div className="card-footer">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
}